import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#363531' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M3 4.5A1.5 1.5 0 014.5 3h15A1.5 1.5 0 0121 4.5v15a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 19.5v-15zm16.5 0h-15v15h15v-15z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M16.5 1.5a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75zM7.5 1.5a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75zM3 8.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 8.25zM7.875 12a.75.75 0 01.75-.75h2.625a.75.75 0 01.586 1.219l-.83 1.037a2.249 2.249 0 11-2.846 3.458.75.75 0 011.062-1.06.75.75 0 10.53-1.279.75.75 0 01-.588-1.219l.526-.656H8.625a.75.75 0 01-.75-.75zM15.335 11.33a.75.75 0 01.415.67v4.875a.75.75 0 01-1.5 0V13.5l-.3.225a.75.75 0 11-.9-1.2l1.5-1.125a.75.75 0 01.785-.07z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
